export default __webpack_public_path__ + "static/media/Photograph Signature 400.fd3e04eb.ttf";